module.exports = __webpack_public_path__ + "static/media/media.4cb46898.png";